// extracted by mini-css-extract-plugin
export default {"item":"styles_item__GHNIo","counter-wrapper":"styles_counter-wrapper__JCGvN","percent-wrapper":"styles_percent-wrapper__gxbus"};